import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { LinkIcon } from "@heroicons/react/outline";
import { useState } from "react";
import { useParams } from "react-router-dom";
import DatasetGroup from "./DatasetGroup";
import PipelineGroup from "./PipelineGroup";

const RelatedContentDialog = () => {
  const { promptId } = useParams();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button size="sm" variant="outline" onClick={() => setOpen(true)}>
            <LinkIcon className="mr-2 h-4 w-4" /> Datasets & Evaluations
          </Button>
        </DialogTrigger>

        <DialogContent className="max-h-[80vh] max-w-3xl overflow-hidden">
          <DialogHeader>
            <DialogTitle>Datasets & Evaluations</DialogTitle>
          </DialogHeader>
          <div
            className="flex flex-col gap-y-2 overflow-y-auto pr-2"
            style={{ maxHeight: "calc(80vh - 80px)" }}
          >
            <PipelineGroup promptId={Number(promptId)} />
            <hr className="my-4" />
            <DatasetGroup promptId={Number(promptId)} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RelatedContentDialog;
